import { createAction, handleActions } from 'redux-actions'
import { sendApiRequest, getCoordsFromAddress, sendApiFileRequest } from 'utils/api'
import { getClientId } from 'utils/utils'
import { v4 } from 'uuid'

export const GET_SPARES_COUNT = 'GET_SPARES_COUNT'
export const getSparesCount = (search) => {
  return (dispatch, getState) => {
    dispatch(createAction(GET_SPARES_COUNT)())
    const options = {}
    const clientId = getClientId(getState)
    options.where = {
      and: [
        { clientId }
      ]
    }
    if (search) {
      options.where.and.push(search)
    }
    sendApiRequest('Spares/count', {
      accessToken: getState().auth.account.accessToken
    }, 'get', options).then((response) => {
      if (response.status === 'failure') {
        dispatch(getSparesCountError(response))
      }
      if (response.status === 'success') {
        dispatch(getSparesCountSuccess(response.data.count))
      }
    })
  }
}

export const GET_SPARES_COUNT_SUCCESS = 'GET_SPARES_COUNT_SUCCESS'
export const getSparesCountSuccess = createAction(GET_SPARES_COUNT_SUCCESS)

export const GET_SPARES_COUNT_ERROR = 'GET_SPARES_COUNT_ERROR'
export const getSparesCountError = createAction(GET_SPARES_COUNT_ERROR)

export const GET_SPARES = 'GET_SPARES'
export const getSpares = (pageSize, pageNumber, search) => {
  return (dispatch, getState) => {
    const clientId = getClientId(getState)
    const options = {
      filter: {
        order: ['lastInspectedDate DESC', 'createdAt DESC'],
        where: {
          and: [
            { clientId }
          ]
        }
      }
    }
    if (pageSize !== 0) {
      options.filter.limit = pageSize
    }
    if (pageNumber !== 1) {
      options.filter.skip = (pageNumber - 1) * pageSize
    }
    if (search) {
      options.filter.where.and.push(search)
    }
    dispatch(createAction(GET_SPARES)())
    sendApiRequest('Spares/sql', {
      accessToken: getState().auth.account.accessToken
    }, 'get', options).then((response) => {
      if (response.status === 'failure') {
        dispatch(getSparesError(response))
      }
      if (response.status === 'success') {
        dispatch(getSparesSuccess(response.data))
      }
    })
  }
}

export const GET_SPARES_SUCCESS = 'GET_SPARES_SUCCESS'
export const getSparesSuccess = createAction(GET_SPARES_SUCCESS)

export const GET_SPARES_ERROR = 'GET_SPARES_ERROR'
export const getSparesError = createAction(GET_SPARES_ERROR)

export const GET_SPARE_BY_ID = 'GET_SPARE_BY_ID'
export const getSpareById = (id) => {
  return (dispatch, getState) => {
    dispatch(createAction(GET_SPARE_BY_ID)())
    sendApiRequest(`Spares/${id}`, {
      accessToken: getState().auth.account.accessToken
    }, 'get').then((response) => {
      if (response.status === 'failure') {
        dispatch(getSpareByIdError(response))
      }
      if (response.status === 'success') {
        // if (response.data.address) {
        //   dispatch(getSpareCoords(response.data.address))
        // }
        dispatch(getSpareByIdSuccess(response.data))
      }
    })
  }
}

export const GET_SPARE_BY_ID_SUCCESS = 'GET_SPARE_BY_ID_SUCCESS'
export const getSpareByIdSuccess = createAction(GET_SPARE_BY_ID_SUCCESS)

export const GET_SPARE_BY_ID_ERROR = 'GET_SPARE_BY_ID_ERROR'
export const getSpareByIdError = createAction(GET_SPARE_BY_ID_ERROR)

export const GET_SPARE_AUDITS_BY_SPARE_ID = 'GET_SPARE_AUDITS_BY_SPARE_ID'
export const getSpareAuditsBySpareId = (spareId) => {
  return (dispatch, getState) => {
    dispatch(createAction(GET_SPARE_AUDITS_BY_SPARE_ID)())
    const options = {
      filter: {
        order: 'inspectionDate DESC',
        limit: 5,
        where: {
          and: [
            { spareId }
          ]
        }
      }
    }
    sendApiRequest('SpareAudits', {
      accessToken: getState().auth.account.accessToken
    }, 'get', options).then((response) => {
      if (response.status === 'failure') {
        dispatch(getSpareAuditsBySpareIdError(response))
      }
      if (response.status === 'success') {
        dispatch(getSpareAuditsBySpareIdSuccess(response.data))
      }
    })
  }
}

export const GET_SPARE_AUDITS_BY_SPARE_ID_SUCCESS = 'GET_SPARE_AUDITS_BY_SPARE_ID_SUCCESS'
export const getSpareAuditsBySpareIdSuccess = createAction(GET_SPARE_AUDITS_BY_SPARE_ID_SUCCESS)

export const GET_SPARE_AUDITS_BY_SPARE_ID_ERROR = 'GET_SPARE_AUDITS_BY_SPARE_ID_ERROR'
export const getSpareAuditsBySpareIdError = createAction(GET_SPARE_AUDITS_BY_SPARE_ID_ERROR)

export const GET_SPARE_COORDS = 'GET_SPARE_COORDS'
export const getSpareCoords = (address) => {
  return (dispatch) => {
    getCoordsFromAddress(address).then((response) => {
      if (response && response.status === 'success') {
        dispatch(getSpareCoordsSuccess(response.data))
      }
    })
  }
}

export const GET_SPARE_COORDS_SUCCESS = 'GET_SPARE_COORDS_SUCCESS'
export const getSpareCoordsSuccess = createAction(GET_SPARE_COORDS_SUCCESS)

export const GET_SPARE_BY_ID_RESET = 'GET_SPARE_BY_ID_RESET'
export const getSpareByIdReset = createAction(GET_SPARE_BY_ID_RESET)

export const DELETE_SPARE_BY_ID = 'DELETE_SPARE_BY_ID'
export const deleteSpareById = (id) => {
  return (dispatch, getState) => {
    dispatch(createAction(DELETE_SPARE_BY_ID)())
    sendApiRequest(`Spares/${id}`, {
      accessToken: getState().auth.account.accessToken
    }, 'delete').then((response) => {
      if (response.status === 'failure') {
        dispatch(deleteSpareByIdError(response.data))
      }
      if (response.status === 'success') {
        dispatch(deleteSpareByIdSuccess(response.data))
      }
    })
  }
}

export const DELETE_SPARE_BY_ID_SUCCESS = 'DELETE_SPARE_BY_ID_SUCCESS'
export const deleteSpareByIdSuccess = createAction(DELETE_SPARE_BY_ID_SUCCESS)

export const DELETE_SPARE_BY_ID_ERROR = 'DELETE_SPARE_BY_ID_ERROR'
export const deleteSpareByIdError = createAction(DELETE_SPARE_BY_ID_ERROR)

export const DELETE_SPARE_BY_ID_RESET = 'DELETE_SPARE_BY_ID_RESET'
export const deleteSpareByIdReset = createAction(DELETE_SPARE_BY_ID_RESET)

// export const CREATE_NEW_SPARE = 'CREATE_NEW_SPARE'
// export const createNewSpare = (data) => {
//   return (dispatch, getState) => {
//     dispatch(createAction(CREATE_NEW_SPARE)())
//     const spareData = data
//     spareData.accessToken = getState().auth.account.accessToken
//     sendApiRequest(`Spares`, spareData, 'post').then((response) => {
//       if (response.status === 'failure') {
//         dispatch(createNewSpareError(response))
//       }
//       if (response.status === 'success') {
//         dispatch(createNewSpareSuccess(response.data))
//       }
//     })
//   }
// }

export const CREATE_NEW_SPARE_SUCCESS = 'CREATE_NEW_SPARE_SUCCESS'
export const createNewSpareSuccess = createAction(CREATE_NEW_SPARE_SUCCESS)

export const CREATE_NEW_SPARE_ERROR = 'CREATE_NEW_SPARE_ERROR'
export const createNewSpareError = createAction(CREATE_NEW_SPARE_ERROR)

export const EDIT_SPARE = 'EDIT_SPARE'
export const editSpare = (data) => {
  return (dispatch, getState) => {
    dispatch(createAction(EDIT_SPARE)())
    const spareData = data
    spareData.accessToken = getState().auth.account.accessToken
    sendApiRequest(`Spares/${data.spareId}`, spareData, 'patch').then((response) => {
      if (response.status === 'failure') {
        dispatch(createNewSpareError(response))
      }
      if (response.status === 'success') {
        dispatch(createNewSpareSuccess(response.data))
      }
    })
  }
}

export const RESET_SPARE_FORM = 'RESET_SPARE_FORM'
export const resetSpareForm = createAction(RESET_SPARE_FORM)

export const OPEN_SPARE_DIALOG = 'OPEN_SPARE_DIALOG'
export const openSpareDialog = createAction(OPEN_SPARE_DIALOG)

export const CLOSE_SPARE_DIALOG = 'CLOSE_SPARE_DIALOG'
export const closeSpareDialog = createAction(CLOSE_SPARE_DIALOG)

export const UPLOAD_SPARE_PHOTO_FILES = 'UPLOAD_SPARE_PHOTO_FILES'
export const uploadSparePhotoFiles = (files, spareId) => {
  return (dispatch, getState) => {
    if (files && files.length > 0) {
      dispatch(createAction(UPLOAD_SPARE_PHOTO_FILES)())
      const promiseArray = files.map((file) => {
        return new Promise((resolve, reject) => {
          const uuid = v4()
          const extension = file.name.split('.').pop()
          const fileName =
          `spare_photos/${spareId}/${uuid}.${extension}`
          const data = new FormData()
          data.append('file', file, fileName)
          data.accessToken = getState().auth.account.accessToken
          sendApiFileRequest(`Spares/${spareId}/file`, data, 'post')
            .then((response) => {
              resolve(response)
            }).catch((err) => { reject(err) })
        })
      })
      Promise.all(promiseArray).then((response) => {
        dispatch(uploadSparePhotoFilesSuccess(response))
      })
    }
  }
}

export const UPLOAD_SPARE_PHOTO_FILES_SUCCESS = 'UPLOAD_SPARE_PHOTO_FILES_SUCCESS'
export const uploadSparePhotoFilesSuccess = createAction(UPLOAD_SPARE_PHOTO_FILES_SUCCESS)

export const UPLOAD_SPARE_PHOTO_FILES_ERROR = 'UPLOAD_SPARE_PHOTO_FILES_ERROR'
export const uploadSparePhotoFilesError = createAction(UPLOAD_SPARE_PHOTO_FILES_ERROR)

export const DELETE_SPARE_PHOTO_FILES = 'DELETE_SPARE_PHOTO_FILES'
export const deleteSparePhotoFiles = (ids) => {
  return (dispatch, getState) => {
    dispatch(createAction(DELETE_SPARE_PHOTO_FILES)())
    const promiseArray = ids.map((id) => {
      return new Promise((resolve, reject) => {
        const data = {}
        data.accessToken = getState().auth.account.accessToken
        sendApiFileRequest(`SparePhotos/${id}`, data, 'delete')
          .then((response) => {
            resolve(response)
          }).catch((err) => { reject(err) })
      })
    })
    Promise.all(promiseArray).then((response) => {
      dispatch(deleteSparePhotoFilesSuccess(response))
    })
  }
}

export const DELETE_SPARE_PHOTO_FILES_SUCCESS = 'DELETE_SPARE_PHOTO_FILES_SUCCESS'
export const deleteSparePhotoFilesSuccess = createAction(DELETE_SPARE_PHOTO_FILES_SUCCESS)

export const DELETE_SPARE_PHOTO_FILES_ERROR = 'DELETE_SPARE_PHOTO_FILES_ERROR'
export const deleteSparePhotoFilesError = createAction(DELETE_SPARE_PHOTO_FILES_ERROR)

export const GET_SPARES_LIKE_NAME = 'GET_SPARES_LIKE_NAME'
export const getSparesLikeName = (sparesName) => {
  return (dispatch, getState) => {
    const clientId = getClientId(getState)
    dispatch(createAction(GET_SPARES_LIKE_NAME)())
    const filter = {
      filter: {
        limit: 5,
        where: {
          and: [
            {
              product: {
                like: `%25${sparesName}%25`
              }
            },
            { clientId }
          ]
        }
      }
    }
    sendApiRequest('Spares', {
      accessToken: getState().auth.account.accessToken
    }, 'get', filter).then((response) => {
      if (response.status === 'failure') {
        dispatch(getSparesLikeNameError(response))
      }
      if (response.status === 'success') {
        dispatch(getSparesLikeNameSuccess(response.data))
      }
    })
  }
}

export const GET_SPARES_LIKE_NAME_SUCCESS = 'GET_SPARES_LIKE_NAME_SUCCESS'
export const getSparesLikeNameSuccess = createAction(GET_SPARES_LIKE_NAME_SUCCESS)

export const GET_SPARES_LIKE_NAME_ERROR = 'GET_SPARES_LIKE_NAME_ERROR'
export const getSparesLikeNameError = createAction(GET_SPARES_LIKE_NAME_ERROR)

export const GET_SPARES_AUDITS = 'GET_SPARES_AUDITS'
export const getSparesAudits = (data) => {
  return (dispatch, getState) => {
    dispatch(createAction(GET_SPARES_AUDITS)())
    let options = {}
    if (data.startDate && data.endDate) {
      options = {
        filter: {
          order: 'inspectionDate DESC',
          where: {
            inspectionDate: {
              between: [data.startDate, data.endDate]
            }
          },
          include: {
            relation: 'spare',
            scope: {
              fields: ['id', 'product', 'qty', 'unit']
            }
          }
        }
      }
    }
    sendApiRequest('SpareAudits', {
      accessToken: getState().auth.account.accessToken
    }, 'get', options).then((response) => {
      if (response.status === 'failure') {
        dispatch(getSparesAuditsError(response))
      }
      if (response.status === 'success') {
        dispatch(getSparesAuditsSuccess(response.data))
      }
    })
  }
}

export const GET_SPARES_AUDITS_SUCCESS = 'GET_SPARES_AUDITS_SUCCESS'
export const getSparesAuditsSuccess = createAction(GET_SPARES_AUDITS_SUCCESS)

export const GET_SPARES_AUDITS_ERROR = 'GET_SPARES_AUDITS_ERROR'
export const getSparesAuditsError = createAction(GET_SPARES_AUDITS_ERROR)

export const GET_SPARES_AUDITS_COUNT = 'GET_SPARES_AUDITS_COUNT'
export const getSparesAuditsCount = (data) => {
  return (dispatch, getState) => {
    dispatch(createAction(GET_SPARES_AUDITS_COUNT)())
    let options = {}
    if (data.startDate && data.endDate) {
      options = {
        filter: {
          where: {
            inspectionDate: {
              between: [data.startDate, data.endDate]
            }
          }
        }
      }
    }
    sendApiRequest('SpareAudits/count', {
      accessToken: getState().auth.account.accessToken
    }, 'get', options).then((response) => {
      if (response.status === 'failure') {
        dispatch(getSparesAuditsCountError(response))
      }
      if (response.status === 'success' && response.data.count) {
        dispatch(getSparesAuditsCountSuccess(response.data.count))
      }
    })
  }
}

export const GET_SPARES_AUDITS_COUNT_SUCCESS = 'GET_SPARES_AUDITS_COUNT_SUCCESS'
export const getSparesAuditsCountSuccess = createAction(GET_SPARES_AUDITS_COUNT_SUCCESS)

export const GET_SPARES_AUDITS_COUNT_ERROR = 'GET_SPARES_AUDITS_COUNT_ERROR'
export const getSparesAuditsCountError = createAction(GET_SPARES_AUDITS_COUNT_ERROR)

export const CREATE_SPARE_AUDIT = 'CREATE_SPARE_AUDIT'
export const createSpareAudit = (data) => {
  return (dispatch, getState) => {
    dispatch(createAction(CREATE_SPARE_AUDIT)())
    const assetData = data
    assetData.accessToken = getState().auth.account.accessToken
    assetData.inspectedBy = getState().auth.account.id
    sendApiRequest('SpareAudits', assetData, 'post').then((response) => {
      if (response.status === 'failure') {
        dispatch(createSpareAuditError(response))
      }
      if (response.status === 'success') {
        dispatch(createSpareAuditSuccess(response.data))
      }
    })
  }
}

export const CREATE_SPARE_AUDIT_SUCCESS = 'CREATE_SPARE_AUDIT_SUCCESS'
export const createSpareAuditSuccess = createAction(CREATE_SPARE_AUDIT_SUCCESS)

export const CREATE_SPARE_AUDIT_ERROR = 'CREATE_SPARE_AUDIT_ERROR'
export const createSpareAuditError = createAction(CREATE_SPARE_AUDIT_ERROR)

export const UPLOAD_SPARE_EXCEL = 'UPLOAD_SPARE_EXCEL'
export const uploadSpareExcel = (data) => {
  return (dispatch, getState) => {
    dispatch(createAction(UPLOAD_SPARE_EXCEL)())
    // console.log(data)
    const dataToSend = {
      accessToken: getState().auth.account.accessToken,
      userId: getState().auth.account.id,
      clientId: getClientId(getState),
      data
    }
    sendApiRequest('Spares/excel', dataToSend, 'post').then((response) => {
      if (response.status === 'failure') {
        dispatch(uploadSpareExcelError(response.data))
      }
      if (response.status === 'success') {
        dispatch(uploadSpareExcelSuccess(response.data))
      }
    })
  }
}

export const UPLOAD_SPARE_EXCEL_SUCCESS = 'UPLOAD_SPARE_EXCEL_SUCCESS'
export const uploadSpareExcelSuccess = createAction(UPLOAD_SPARE_EXCEL_SUCCESS)

export const UPLOAD_SPARE_EXCEL_ERROR = 'UPLOAD_SPARE_EXCEL_ERROR'
export const uploadSpareExcelError = createAction(UPLOAD_SPARE_EXCEL_ERROR)


const initialState = {
  sparesCount: 0,
  isGettingSpares: false,
  hasGottenSpares: false,
  spares: [],
  getSparesError: {},
  selectedSpare: {},
  isGettingSpare: false,
  hasGottenSpare: false,
  getSpareError: {},
  isDeletingSpare: false,
  hasDeletedSpare: false,
  deleteSpareSuccess: {},
  deleteSpareError: {},
  selectedSpareCoords: {},
  isCreatingSpare: false,
  hasCreatedSpare: false,
  createSpareSuccess: {},
  createSpareError: {},
  spareDialogIsOpen: false,
  selectedSpareToEdit: {},
  isDeletingSparePhotoFiles: false,
  hasDeletedSparePhotoFiles: false,
  getSparesLikeName: false,
  sparesLike: [],
  isGettingSpareAuditsBySpareId: false,
  hasGottenSpareAuditsBySpareId: false,
  spareAuditsBySpareId: [],
  isCreatingSpareAudit: false,
  hasCreatedSpareAudit: false,
  createdSpareAudit: {},
  isGettingSparesAudits: false,
  hasGottenSparesAudits: false,
  sparesAudits: [],
  isGettingSparesAuditsCount: false,
  hasGottenSparesAuditsCount: false,
  sparesAuditsCount: 0,
  isUploadingSpareExcel: false,
  hasUploadedSpareExcel: false,
  uploadSpareExcelSuccess: {},
  uploadSpareExcelError: {}
}

export default handleActions({

  [GET_SPARES]: (state) => ({
    ...state,
    isGettingSpares: true,
    hasGottenSpares: false
  }),

  [GET_SPARES_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      isGettingSpares: false,
      hasGottenSpares: true,
      spares: payload
    }
  },

  [GET_SPARES_ERROR]: (state, { payload }) => {
    return {
      ...state,
      isGettingSpares: false,
      hasGottenSpares: false,
      getSparesError: payload
    }
  },

  [GET_SPARES_COUNT_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      sparesCount: payload
    }
  },

  [GET_SPARE_BY_ID]: (state) => ({
    ...state,
    selectedSpareCoords: {},
    isGettingSpare: true,
    hasGottenSpare: false
  }),

  [GET_SPARE_BY_ID_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      isGettingSpare: false,
      hasGottenSpare: true,
      selectedSpare: payload
    }
  },

  [GET_SPARE_BY_ID_ERROR]: (state, { payload }) => {
    return {
      ...state,
      isGettingSpare: false,
      hasGottenSpare: false,
      getSpareError: payload
    }
  },
  [GET_SPARE_BY_ID_RESET]: (state) => ({
    ...state,
    isGettingSpare: false,
    hasGottenSpare: false,
    selectedSpare: {}
  }),

  [DELETE_SPARE_BY_ID]: (state) => ({
    ...state,
    isDeletingSpare: true,
    hasDeletedSpare: false
  }),

  [DELETE_SPARE_BY_ID_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      isDeletingSpare: false,
      hasDeletedSpare: true,
      deleteSpareSuccess: payload
    }
  },

  [DELETE_SPARE_BY_ID_ERROR]: (state, { payload }) => {
    return {
      ...state,
      isDeletingSpare: false,
      hasDeletedSpare: false,
      deleteSpareError: payload
    }
  },

  [DELETE_SPARE_BY_ID_RESET]: (state) => {
    return {
      ...state,
      isDeletingSpare: false,
      hasDeletedSpare: false,
      deleteSpareError: {},
      deleteSpareSuccess: {}
    }
  },

  [GET_SPARE_COORDS_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      selectedSpareCoords: payload
    }
  },

  // [CREATE_NEW_SPARE]: (state, { payload }) => {
  //   return {
  //     ...state,
  //     isCreatingSpare: true,
  //     hasCreatedSpare: false,
  //     createSpareSuccess: {},
  //     createSpareError: {}
  //   }
  // },

  [CREATE_NEW_SPARE_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      isCreatingSpare: false,
      hasCreatedSpare: true,
      createSpareSuccess: payload
    }
  },

  [CREATE_NEW_SPARE_ERROR]: (state, { payload }) => {
    return {
      ...state,
      isCreatingSpare: false,
      hasCreatedSpare: false,
      createSpareError: payload
    }
  },

  [CREATE_SPARE_AUDIT]: (state) => {
    return {
      ...state,
      isCreatingSpareAudit: true,
      hasCreatedSpareAudit: false,
      createdSpareAudit: {}
    }
  },

  [CREATE_SPARE_AUDIT_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      isCreatingSpareAudit: false,
      hasCreatedSpareAudit: true,
      createdSpareAudit: payload
    }
  },

  [CREATE_SPARE_AUDIT_ERROR]: (state) => {
    return {
      ...state,
      isCreatingSpareAudit: false,
      hasCreatedSpareAudit: false,
      createdSpareAudit: {}
    }
  },

  [EDIT_SPARE]: (state) => {
    return {
      ...state,
      isCreatingSpare: true,
      hasCreatedSpare: false,
      createSpareSuccess: {},
      createSpareError: {}
    }
  },

  [OPEN_SPARE_DIALOG]: (state, { payload }) => {
    return {
      ...state,
      spareDialogIsOpen: true,
      selectedSpareToEdit: payload
    }
  },

  [CLOSE_SPARE_DIALOG]: (state) => {
    return {
      ...state,
      spareDialogIsOpen: false,
      selectedSpareToEdit: {},
      isCreatingSpare: false,
      hasCreatedSpare: false,
      createSpareSuccess: {},
      createSpareError: {}
    }
  },

  [DELETE_SPARE_PHOTO_FILES]: (state) => {
    return {
      ...state,
      isDeletingSparePhotoFiles: true,
      hasDeletedSparePhotoFiles: false
    }
  },

  [DELETE_SPARE_PHOTO_FILES_SUCCESS]: (state) => {
    return {
      ...state,
      isDeletingSparePhotoFiles: false,
      hasDeletedSparePhotoFiles: true
    }
  },

  [DELETE_SPARE_PHOTO_FILES_ERROR]: (state) => {
    return {
      ...state,
      isDeletingSparePhotoFiles: false,
      hasDeletedSparePhotoFiles: false
    }
  },
  [GET_SPARES_LIKE_NAME]: (state) => {
    return {
      ...state,
      getSparesLikeName: true,
      sparesLikeName: []
    }
  },

  [GET_SPARES_LIKE_NAME_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      getSparesLikeName: false,
      sparesLikeName: payload
    }
  },

  [GET_SPARES_LIKE_NAME_ERROR]: (state) => {
    return {
      ...state,
      getSparesLikeName: false,
      sparesLikeName: []
    }
  },

  [GET_SPARE_AUDITS_BY_SPARE_ID]: (state) => ({
    ...state,
    isGettingSpareAuditsBySpareId: true,
    hasGottenSpareAuditsBySpareId: false,
    spareAuditsBySpareId: []
  }),

  [GET_SPARE_AUDITS_BY_SPARE_ID_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      isGettingSpareAuditsBySpareId: false,
      hasGottenSpareAuditsBySpareId: true,
      spareAuditsBySpareId: payload
    }
  },

  [GET_SPARE_AUDITS_BY_SPARE_ID_ERROR]: (state) => {
    return {
      ...state,
      isGettingSpareAuditsBySpareId: false,
      hasGottenSpareAuditsBySpareId: false,
      spareAuditsBySpareId: []
    }
  },

  [GET_SPARES_AUDITS]: (state) => {
    return {
      ...state,
      isGettingSparesAudits: true,
      hasGottenSparesAudits: false,
      sparesAudits: []
    }
  },

  [GET_SPARES_AUDITS_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      isGettingSparesAudits: false,
      hasGottenSparesAudits: true,
      sparesAudits: payload
    }
  },

  [GET_SPARES_AUDITS_ERROR]: (state) => {
    return {
      ...state,
      isGettingSparesAudits: false,
      hasGottenSparesAudits: false,
      sparesAudits: []
    }
  },

  [GET_SPARES_AUDITS_COUNT]: (state) => {
    return {
      ...state,
      isGettingSparesAuditsCount: true,
      hasGottenSparesAuditsCount: false,
      sparesAuditsCount: 0
    }
  },

  [GET_SPARES_AUDITS_COUNT_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      isGettingSparesAuditsCount: false,
      hasGottenSparesAuditsCount: true,
      sparesAuditsCount: payload
    }
  },

  [GET_SPARES_AUDITS_COUNT_ERROR]: (state) => {
    return {
      ...state,
      isGettingSparesAuditsCount: false,
      hasGottenSparesAuditsCount: false,
      sparesAuditsCount: 0
    }
  },

  [UPLOAD_SPARE_EXCEL]: (state) => {
    return {
      ...state,
      isUploadingSpareExcel: true,
      hasUploadedSpareExcel: false,
      uploadSpareExcelSuccess: {},
      uploadSpareExcelError: {}
    }
  },

  [UPLOAD_SPARE_EXCEL_SUCCESS]: (state, { payload }) => {
    return {
      ...state,
      isUploadingSpareExcel: false,
      hasUploadedSpareExcel: true,
      uploadSpareExcelSuccess: payload
    }
  },

  [UPLOAD_SPARE_EXCEL_ERROR]: (state, { payload }) => {
    return {
      ...state,
      isUploadingSpareExcel: false,
      hasUploadedSpareExcel: false,
      uploadSpareExcelError: payload
    }
  }
}, initialState)